import { useContext } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import { CustomersContext } from "../../../contexts/customers/customers.context";

const CUSTOMER = {
  id: "",
  business_name: "",
  firstname: "",
  lastname: "",
  fullname: "",
  email: "",
  phone: "",
  address: "",
  address_2: "",
  city: "",
  state: "",
  zip: "",
  business_and_full_name: "",
  created_at: "",
  updated_at: "",
};

const CHANGE_HANDLERS = {
  handleChange: () => {},
};

const GetCustomerFormProps = ({
  formObject = CUSTOMER,
  changeHandlers = CHANGE_HANDLERS,
}) => {
  const { handleChange } = changeHandlers;
  const navigate = useNavigate(); // Initialize the useNavigate hook

  const {
    id,
    business_name,
    firstname,
    lastname,
    fullname,
    email,
    phone,
    address,
    address_2,
    city,
    state,
    zip,
    business_and_full_name,
    created_at,
    updated_at,
  } = formObject;

  return {
    id: {
      type: "text",
      props: {
        label: "ID",
        value: id,
        name: "id",
        onChange: handleChange,
        className: "w-96",
      },
    },
    business_name: {
      type: "text", // Set type to "button" for clickable behavior
      props: {
        label: "Business Name",
        text: business_name,
        value: business_name,
        name: "business_name",
        className: "w-96 cursor-pointer text-blue-600 underline",
        onClick: () =>
            navigate(`/custticekt`, {
                state: { customer: formObject }, 
            }),
           // Navigate to the desired route on click
      },
    },
    firstname: {
      type: "text",
      props: {
        label: "First Name",
        value: firstname,
        name: "firstname",
        onChange: handleChange,
        className: "w-96",
      },
    },
    lastname: {
      type: "text",
      props: {
        label: "Last Name",
        value: lastname,
        name: "lastname",
        onChange: handleChange,
        className: "w-96",
      },
    },
    fullname: {
      type: "text",
      props: {
        label: "Full Name",
        value: fullname,
        name: "fullname",
        onChange: handleChange,
        className: "w-96",
      },
    },
    email: {
      type: "email",
      props: {
        label: "Email",
        value: email,
        name: "email",
        onChange: handleChange,
        className: "w-96",
      },
    },
    phone: {
      type: "text",
      props: {
        label: "Phone",
        value: phone,
        name: "phone",
        onChange: handleChange,
        className: "w-96",
      },
    },
    address: {
      type: "text",
      props: {
        label: "Address Line 1",
        value: address,
        name: "address",
        onChange: handleChange,
        className: "w-96",
      },
    },
    address_2: {
      type: "text",
      props: {
        label: "Address Line 2",
        value: address_2,
        name: "address_2",
        onChange: handleChange,
        className: "w-96",
      },
    },
    city: {
      type: "text",
      props: {
        label: "City",
        value: city,
        name: "city",
        onChange: handleChange,
        className: "w-96",
      },
    },
    state: {
      type: "text",
      props: {
        label: "State",
        value: state,
        name: "state",
        onChange: handleChange,
        className: "w-96",
      },
    },
    zip: {
      type: "text",
      props: {
        label: "ZIP Code",
        value: zip,
        name: "zip",
        onChange: handleChange,
        className: "w-96",
      },
    },
    business_and_full_name: {
      type: "text",
      props: {
        label: "Business & Full Name",
        value: business_and_full_name,
        name: "business_and_full_name",
        onChange: handleChange,
        className: "w-96",
      },
    },
    created_at: {
      type: "datetime",
      props: {
        label: "Created At",
        value: created_at,
        name: "created_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
    updated_at: {
      type: "datetime",
      props: {
        label: "Updated At",
        value: updated_at,
        name: "updated_at",
        onChange: handleChange,
        className: "w-96",
      },
    },
  };
};

export default GetCustomerFormProps;
